common.View.create('partners::website.modules.partners.contentItems.Socials', {

    onDOMLoad() {
        this.initButtons();
    },

    initButtons() {
        this.element.find('a')
            .click((event) => {
                window.open(
                    $(event.currentTarget).attr('href'),
                    'Share',
                    'height=450, width=600, top=' + ($(window).height() / 2 - (450 / 2)) + ', left=' + ($(window).width() / 2 - (600 / 2)) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0'
                );
                return false;
            });
    },
});
